export default {
    props: [
        'seismicDesignId',
    ],

    computed: {
        seismicDesignRecord() {
            return this.$store.state['seismicDesign'].records[this.seismicDesignId];
        },
    },

    mounted() {
        if (!this.seismicDesignRecord && this.seismicDesignId ) {
            this.$store.dispatch('seismicDesign/show', { id: this.seismicDesignId })
        }
    },
};
